import { tns } from 'tiny-slider/src/tiny-slider';

class ImageGallerySlider {
	constructor(el, nav) {
		console.log(this.nav);
		this.el = el;
		this.nav = nav;

        const imageGallerySlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
        });
    
        return imageGallerySlider;
		
	}
}

export default ImageGallerySlider;